import Image from 'next/image'
import paperTearBlueImage from '@/images/localized/paper-tear-sm-blue.png'
import { Container } from '@/shared/components/Container'
import Link from 'next/link'
import React from 'react'
import { ALL_SERVICES_AD } from '@/lib/constants/services'

export default function ServicesAdWithPaperTear() {
  return (
    <div className="z-[1]">
      <div className="w-full">
        <Image
          src={paperTearBlueImage}
          alt="paper tear image background"
          className="h-auto w-full scale-y-[-1]"
        />
      </div>
      <div className="-mt-0.5 bg-blue-600 py-20">
        <Container className="flex flex-col items-center gap-y-12">
          <h2 className="text-center font-bitter text-xl text-white md:text-2xl xl:text-3xl">
            Skip the waiting room and start your online GP consultation here
          </h2>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-6">
            {ALL_SERVICES_AD.map(({ title, link }, idx) => (
              <Link
                key={idx}
                href={link}
                className="rounded-full border border-gray-200 px-8 py-1.5 font-sans text-lg font-light text-gray-200 transition-colors ease-out hover:bg-gray-200 hover:text-blue-600 md:px-10 md:py-2 md:text-xl xl:px-12 xl:py-2.5 xl:text-2xl"
              >
                {title}
              </Link>
            ))}
          </div>
        </Container>
      </div>
    </div>
  )
}
